import React from 'react';
import { byggOffertVillkor } from '../../utils/offertVillkor';

/**
 * Sub-komponent: Header med expand/collapse-knapp
 */
const TermsHeader = ({ isExpanded, onToggle }) => (
  <button
    onClick={onToggle}
    className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors"
  >
    <h2 className="text-lg font-semibold text-leadme-gray-dark">Villkor</h2>
    <svg
      className={`w-5 h-5 text-gray-500 transform transition-transform ${
        isExpanded ? 'rotate-180' : ''
      }`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>
);

/**
 * Sub-komponent: Själva villkorstexten.
 *
 * Texten bor i utils/offertVillkor.js och delas med PDF-genereringen. Den låg
 * tidigare inskriven här också, och kopiorna hade glidit isär. Skriv inte
 * tillbaka någon villkorstext i den här filen — ändra i modulen i stället, så
 * följer både skärm och PDF med.
 */
const TermsContent = ({ offert, procurement }) => {
  const villkor = byggOffertVillkor({ offert, procurement });

  return (
    <div className="px-6 pb-6">
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="space-y-4 text-sm text-gray-700 leading-relaxed">
          {villkor.map((punkt, i) => (
            <p key={i} className={punkt.highlight ? 'font-medium text-blue-900' : undefined}>
              {punkt.text}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

/**
 * TermsSection - Visar villkor för offerten
 *
 * Innehållet styrs av byggOffertVillkor: lagtext (utelämnas för BRF),
 * beställarens ansvar, priser för extra arbete, betalplan, innehållning,
 * ROT-punkten (utelämnas för BRF), platsbesök och giltighetstid.
 */
const TermsSection = ({ offert, procurement, isExpanded, onToggle }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
      <TermsHeader isExpanded={isExpanded} onToggle={onToggle} />
      {isExpanded && <TermsContent offert={offert} procurement={procurement} />}
    </div>
  );
};

export default TermsSection;
